<template>
    <!-- 栅格渲染
         @author: liuguisheng
         @date: 2019-11-25
    -->
    <div class="render-grid" v-if="isDisplay">
        <render-item-template v-for="(item) in gridList"
                              :key="item.id"
                              :formNode="item">
        </render-item-template>
    </div>
</template>


<script>
/** 混入方法 ::: 
 *  @mixin mixRenderItemTemplateChild 预览表单子级混入
 */
import { mixRenderItemTemplateChild } from "@/mixins/render_item/mix_render_item_template_child.js";


export default {
    mixins: [ mixRenderItemTemplateChild ],
    computed: {
        /**
         * @name 栅格数据整理
         * @description 栅格渲染需要格式化数据，按照从左到右渲染
         * @returns { Array } 整理后的数据
         * @author liuguisheng
         * @version 2019-11-25
        */
        gridList () {
            // 取出栅格的每一列数据
            let columns = this.formNode.children;
            // 计算栅格中每列单元格最大长度
            let maxCellLength = Math.max.apply(null, columns.map(cell => { return cell.children.length; }));
            let cellArr = [];
            for (let i = 0; i < maxCellLength; i ++) {
                // 横向一行一行取栅格中的每一个单元格，每列的数量可能不一样需要过滤一下有效单元格
                let rowCell = columns.map(cells => cells.children[i]).filter(cell => cell);
                cellArr = [...cellArr, ...rowCell];
            }
            return cellArr;
        }
    }
}
</script>





// WEBPACK FOOTER //
// src/components/render_item/RenderGrid.vue